import gql from 'graphql-tag';

export default gql`
  fragment hubspotDealPipelineStageFragment on HubspotDealPipelineStage {
    id
    label
  }
`;
